import React from "react";

export default function NotFound() {
  return (
    <div className="flex ">
      <h1 className="lg:text-7xl text-center text-4xl pouet flex-col align-middle justify-center">Malheureusement la page n'existe pas :'(</h1>
    </div>
  );
}
